import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        ok: '&',
        update: '&',
        cancel: '&',
        courseId: '=',
        filter: '=?'
    },
    template: `
        <div class="modal-header">
            <button type="button" class="close" ng-click="vm.cancel()"></button>
            <h2>{{ 'planning.Add deadlines' | translate }} <small>{{ vm.course.activeI18n.name }}</small></h2>
            <p ng-if="vm.PrivilegeService.canViewCourses() && vm.course.expirationMonths">{{ vm.getExpirationLabel() }}</p>
        </div>
        <div style="margin-top:20px; position:relative; height:200px" ng-if="vm.loading">
            <div class="loader02">
            {{ 'general.Please wait. Actions with large amount of data take more time than usual' | translate }}
            </div>
        </div>
        <div class="modal-body">
            <div class="heading01">
                <h3>{{ 'planning.Employees' | translate }}</h3>
                <a class="btn filter" ng-click="vm.toggleFilter()">{{ 'filter.Filter employees' | translate }}</a>
            </div>
            <modals-planning-needs-deadline-filter
                show-filter="vm.showFilter"
                filter="vm.filter"
                default-filter="vm.defaultFilter"
                list="vm.list"
             />
             <div class="alert alert-warn" ng-if="vm.hasNotStartedUsers().length > 0">
                {{ "planning.Employees with status 'Not started' can not be added to automated planning group" | translate }}
            </div>
            <pagination-tools list="vm.list" custom-options="[1000,2500]"></pagination-tools>
            <list-factory-empty list="vm.list" show-add-message="false"></list-factory-empty>
            <div class="well" ng-if="!vm.list.loading && vm.list.items.length">
                <div class="loader01" ng-if="vm.list.loading"></div>
                <table class="data01"
                    ng-init="vm.initBulk()"
                    datatable dt-options="vm.DATATABLES">
                    <thead>
                    <tr>
                        <th class="w1p nosort">
                            <input ng-if="vm.PrivilegeService.canManagePlanning()" ng-model="vm.checked" ng-click="vm.toggleAll()" type="checkbox">
                        </th>
                        <th>{{ 'planning.User' | translate }}</th>
                        <th>{{ 'planning.Position' | translate }}</th>
                        <th>{{ 'planning.Previous date completed' | translate }}</th>
                        <th>{{ 'planning.Personal deadline' | translate }}</th>
                        <th>{{ 'planning.Status' | translate }}</th>
                    </tr>
                    </thead>
                    <tbody>
                        <tr ng-repeat="item in vm.list.items">
                            <td><input type="checkbox" ng-if="vm.PrivilegeService.canManagePlanning()" ng-checked="vm.hasUserId(item.userId)"
                            ng-click="$event.stopPropagation();vm.toggleUserId(item.userId)"></td>
                            <td>
                                {{ item.displayName }}
                                <span ng-if="item.planningGroups.length && vm.hasStartedApg(item)" class="badge round badge-positive" uib-tooltip="{{ vm.startedApgToolTip }}">A</span>
                                <span ng-if="item.planningGroups.length && !vm.hasStartedApg(item)" class="badge round badge-warn" uib-tooltip="{{ vm.apgToolTip }}">A</span>
                            </td>
                            <td>
                                <drl-partial-table drls="item.drls"></drl-partial-table>
                            </td>
                            <td>{{ item.previousPassedTime ? vm.MomentService.formatDate(item.previousPassedTime) : '-' }}</td>
                            <td ng-bind-html="item.deadline | personalDeadline: item.previousPassedTime:item.isInfiniteDeadline"></td>
                            <td>{{ vm.USER_STATUS_ENUM.LABELS[item.status] }}</td>
                        </tr>
                    </tbody>
                </table>
                <pagination list="vm.list"></pagination>
            </div>
            <div class="form">
                <form-row error="vm.errors.userIds">
                    <form-row-error></form-row-error>
                </form-row>
                <form-row error="vm.errors.ids">
                    <form-row-error></form-row-error>
                </form-row>
                <form-row error="vm.errors.deadline" ng-if="vm.PrivilegeService.canManagePlanning()">
                    <label class="label">{{ 'planning.Deadline' | translate }}</label>
                    <div class="items">
                        <datepicker-api ng-id="'deadlineDatepicker'" ng-disabled="vm.form.removeDeadline" ng-model="vm.form.deadline"></datepicker-api>
                        <form-row-error></form-row-error>
                    </div>
                </form-row>
                <form-row error="vm.errors.removeDeadline" ng-if="vm.PrivilegeService.canManagePlanning()">
                    <label class="label"></label>
                    <div class="items">
                        <form-row-error></form-row-error>
                        <ul class="checkboxes c-both">
                            <li>
                                <label>
                                    <input
                                        ng-disabled="vm.form.deadline || vm.planningGroupId"
                                        ng-model="vm.form.removeDeadline"
                                        ng-change="vm.clearDeadline('deadlineDatepicker')"
                                        type="checkbox"
                                    >
                                    {{ 'planning.Remove personal deadline' | translate }}
                                </label>
                            </li>
                        </ul>
                    </div>
                </form-row>
            </div>
            <hr ng-if="vm.PrivilegeService.canManagePlanning()" />
            <div class="form" ng-if="vm.PrivilegeService.canManagePlanning()">
                <div class="row">
                    <label class="label">{{ 'planning.Add to automated planning group' | translate }}</label>
                    <div class="items">
                        <div class="items">
                            <select
                                ng-if="vm.planningGroups.length"
                                ng-disabled="vm.form.removeDeadline || vm.disablePlanningGroupSelect"
                                ng-readonly="vm.form.removeDeadline"
                                class="form-control small"
                                ng-model="vm.planningGroupId"
                                ng-change="vm.handleApgChange()"
                                ng-options="item.id as item.name for item in vm.planningGroups">
                                <option value=""></option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <label class="label"></label>
                     <div class="items">
                         <span ng-if="!vm.planningGroups.length">
                            {{ 'planning.No automated planning groups added to course' | translate }}
                        </span>
                         <span ng-if="vm.isForNewEmployees">
                            {{ 'planning.Automated planning group is set up only for new employees' | translate }}
                        </span>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal-footer">
            <ul class="actions01">
                <li  class="primary" ng-if="vm.canSubmit()">
                    <button class="btn main" type="button" ng-click="vm.submit()">{{ 'general.Save' | translate }}</button>
                </li>
                <li><button class="btn discrete" type="button" ng-click="vm.cancel()">{{ 'general.Cancel' | translate }}</button></li>
            </ul>
        </div>
    `
})

export default class {
    constructor ($q, $translate, $rootScope, toastr, moment, lodash, DATATABLES,
                 USER_STATUS_ENUM, AUTOMATED_PLANNING_GROUP_STATUS_ENUM,
                 ListFactory, CourseResource, AutomatedPlanningGroupResource,
                 ModalService, MomentService, PrivilegeService) {
        this.$q = $q;
        this.$translate = $translate;
        this.$rootScope = $rootScope;
        this.toastr = toastr;
        this.lodash = lodash;
        this.moment = moment;
        this.DATATABLES = DATATABLES;
        this.USER_STATUS_ENUM = USER_STATUS_ENUM;
        this.AUTOMATED_PLANNING_GROUP_STATUS_ENUM = AUTOMATED_PLANNING_GROUP_STATUS_ENUM;
        this.ListFactory = ListFactory;
        this.CourseResource = CourseResource;
        this.AutomatedPlanningGroupResource = AutomatedPlanningGroupResource;
        this.ModalService = ModalService;
        this.MomentService = MomentService;
        this.PrivilegeService = PrivilegeService;
        this.loading = false;
        this.isForNewEmployees = false;
    }

    $onInit () {
        this.list = this.ListFactory.createWithPagination(this.CourseResource.trainingNeedUsers.bind(this.CourseResource));
        this.list.pagination.perPage = 25;

        this.twoWeeksNoticeDate = this.moment().add(14, 'days');
        this.course = {};
        this.initDefaultFilter();

        this.startedApgToolTip = this.$translate.instant('planning.Added to started automated planning group');
        this.apgToolTip = this.$translate.instant('planning.Added to automated planning group');

        this.usersWithExistingDeadline = [];

        if (this.PrivilegeService.canViewCourses()) {
            this.CourseResource.get({ id: this.courseId, expand: 'activeI18n' }).$promise.then((course) => {
                this.course = course;
            });
        }

        this.form = { deadline: null };
        if (this.PrivilegeService.canManagePlanning()) {
            this.AutomatedPlanningGroupResource.query({
                courseId: this.courseId,
                planningSites: true
            }).$promise.then((planningGroups) => {
                this.planningGroups = planningGroups;
            });
        }
    }

    initDefaultFilter () {
        if (!this.filter) {
            this.filter = {};
        }

        this.filter.id = this.courseId;
        this.filter.excludePlannedUsers = true;
        this.filter.excludeApgUsers = true;


        if (this.filter.includeApgEmployees) {
            this.filter.excludeApgUsers = !this.filter.includeApgEmployees;
        }

        this.defaultFilter = angular.copy(this.filter);

        this.list.fetch(this.defaultFilter);
    }

    initBulk () {
        this.form.userIds = [];
        this.checked = false;
    }

    clearDeadline (datepickerId) {
        this.$rootScope.$broadcast(`clear:datepicker:${datepickerId}`);
    }

    handleApgChange () {
        const apg = this.planningGroups.find(item => item.id === this.planningGroupId);
        if (apg.maxWorkingSince) {
            this.isForNewEmployees = true;
        }
        else {
            this.isForNewEmployees = false;
        }
    }

    getExpirationLabel () {
        const years = Math.floor(this.course.expirationMonths / 12);
        const months = this.course.expirationMonths % 12;
        const yearsLabel = years > 0 ? this.$translate.instant(
            'planning.expirationYear.{n, plural, one {# year} other {# years}}',
            { n: years }
        ) : false;
        const monthsLabel = months > 0 ? this.$translate.instant(
            'planning.expirationMonth.{n, plural, one {# month} other {# months}}',
            { n: months }
        ) : false;

        if (yearsLabel && monthsLabel) {
            return this.$translate.instant('course.Course expires in {yearsLabel} and {monthsLabel}', {
                yearsLabel, monthsLabel
            });
        }
        else if (yearsLabel || monthsLabel) {
            return this.$translate.instant('course.Course expires in {label}', {
                label: yearsLabel || monthsLabel
            });
        }
        return '';
    }

    toggleAll () {
        this.form.userIds = this.checked ? this.list.items.map((user) => user.userId) : [];
        this.disablePlanningGroupSelect = false;

        if (this.hasNotStartedUsers().length > 0) {
            this.toastr.warning(this.$translate.instant("planning.Employees with status 'Not started' can not be added to automated planning group"));
            this.planningGroupId = null;
            this.disablePlanningGroupSelect = true;
        }
    }

    toggleFilter () {
        this.showFilter = !this.showFilter;
    }

    hasUserId (id) {
        return this.lodash.includes(this.form.userIds, id);
    }

    toggleUserId (id) {
        if (this.hasUserId(id)) {
            this.lodash.pull(this.form.userIds, id);
            this.checked = false;
        }
        else {
            this.form.userIds.push(id);
        }

        this.disablePlanningGroupSelect = false;

        if (this.hasNotStartedUsers().length > 0) {
            if (this.hasNotStartedUser(id)) {
                this.toastr.warning(this.$translate.instant("planning.Employees with status 'Not started' can not be added to automated planning group"));
            }
            this.planningGroupId = null;
            this.disablePlanningGroupSelect = true;
        }
    }

    submit () {
        this.loading = true;
        this.errors = {};
        let message = '';
        const usersWithExistingDeadline = [];
        this.lodash.forEach(this.list.items, (user) => {
            if (user.deadline && this.hasUserId(user.userId)) {
                usersWithExistingDeadline.push(user.displayName);
            }
        });
        const checkedUsers = [];
        this.lodash.forEach(this.list.items, (user) => {
            if (this.hasUserId(user.userId)) {
                checkedUsers.push(user.displayName);
            }
        });

        // if only deadline adding or removal
        if (this.form.removeDeadline || (this.form.deadline && !this.planningGroupId)) {
            // if removal and there is users with existing deadline
            if (this.form.removeDeadline && usersWithExistingDeadline.length) {
                message = this.$translate.instant('planning.needs.confirm.users.deadline.remove', {
                    users: usersWithExistingDeadline.join(', ')
                });
            }
            else if (this.form.deadline && usersWithExistingDeadline.length) {
                message = this.$translate.instant('planning.needs.confirm.users.deadline', {
                    deadline: this.MomentService.formatDate(this.form.deadline),
                    users: usersWithExistingDeadline.join(', ')
                });
            }
            this.trainingNeedRequest(true).then(() => {
                const saveTrainingNeed = () => this.handleRequestPromise(this.trainingNeedRequest());
                if (message) {
                    this.ModalService.confirm(message, 'medium')
                        .then(saveTrainingNeed)
                        .catch(() => {
                            this.loading = false;
                        });
                }
                else {
                    saveTrainingNeed();
                }
            }).catch((response) => this.handleErrorResponse(response));
        }
        else if (this.form.deadline && this.planningGroupId) {
            if (usersWithExistingDeadline.length) {
                // https://jira.opus.ee/browse/COUR-4799 show all checked users in notification
                message = this.$translate.instant('planning.needs.confirm.users.deadline_and_apg', {
                    deadline: this.MomentService.formatDate(this.form.deadline),
                    users: checkedUsers.join(', ')
                });
            }
            else {
                message = this.$translate.instant('planning.needs.confirm.users.apg', {
                    deadline: this.MomentService.formatDate(this.form.deadline),
                    users: checkedUsers.join(', ')
                });
            }
            this.$q.all({
                trainingNeed: this.trainingNeedRequest(true),
                planningGroup: this.addUsersRequest(true)
            })
                .then(() => this.ModalService.confirm(message, 'medium')
                .then(() => this.saveTrainingNeedAddApgUsers()))
                .catch(response => this.handleErrorResponse(response));
        }
        else if (this.planningGroupId) {
            message = this.$translate.instant('planning.needs.confirm.users.apg', {
                deadline: this.MomentService.formatDate(this.form.deadline),
                users: checkedUsers.join(', ')
            });
            this.addUsersRequest(true)
                .then(() => this.ModalService.confirm(message, 'medium').then(
                    () => this.handleRequestPromise(this.addUsersRequest())
                ))
                .catch(response => this.handleErrorResponse(response))
            ;
        }
    }

    saveTrainingNeedAddApgUsers () {
        const sequence = new Promise(resolve => {
            this.trainingNeedRequest()
                .then(() => this.addUsersRequest())
                .then(resolve());
        });

        this.handleRequestPromise(sequence)
            .then(() => {
                this.loading = false;
            });
    }

    addUsersRequest (validateOnly = false) {
        const params = { id: this.planningGroupId };
        if (validateOnly) {
            params.validateOnly = true;
        }
        return this.AutomatedPlanningGroupResource.addUsers(params, { ids: this.form.userIds }).$promise;
    }

    trainingNeedRequest (validateOnly = false) {
        const params = { id: this.courseId };
        if (validateOnly) {
            params.validateOnly = true;
        }
        return this.CourseResource.setTrainingNeed(params, this.form).$promise;
    }

    handleRequestPromise (promise) {
        promise.then(() => {
            this.ok();
            this.update();
        }).catch(response => this.handleErrorResponse(response));
    }

    handleErrorResponse (response) {
        this.loading = false;
        this.errors = {};
        // in case of confirm modal decline action no response is returned to handleErrorResponse()
        // https://jira.opus.ee/browse/COUR-4895
        if (response && response.data) {
            this.lodash.forEach(response.data, (error) => {
                this.errors[error.field] = error.message;
            });
        }
    }

    canSubmit () {
        const canManagePlanning = this.PrivilegeService.canManagePlanning();
        const usersAreLoaded = this.list.items.length;
        const haveSomethingToSubmit =
            (this.form.deadline || this.form.removeDeadline || this.planningGroupId)
            && (this.form.userIds && this.form.userIds.length);

        return canManagePlanning && usersAreLoaded && haveSomethingToSubmit;
    }

    /**
     * @returns {*[]|*}
     */
    hasNotStartedUsers () {
        if (this.list.loading || !this.form.userIds || !this.form.userIds.length) {
            return [];
        }

        return this.form.userIds.filter((id) => {
            return !!this.list.items.find((user) => parseInt(user.userId, 10) === parseInt(id, 10)
                && user.status === this.USER_STATUS_ENUM.KEYS.NOT_STARTED);
        });
    }

    /**
     * @param userId
     * @returns {*}
     */
    hasNotStartedUser (userId) {
        return this.form.userIds.find((id) => {
            return !!this.list.items.find((user) => parseInt(user.userId, 10) === parseInt(id, 10)
                && user.status === this.USER_STATUS_ENUM.KEYS.NOT_STARTED
                && parseInt(user.userId, 10) === parseInt(userId, 10));
        });
    }

    hasStartedApg (item) {
        return item.planningGroups.find((planningGroup) => planningGroup.status === this.AUTOMATED_PLANNING_GROUP_STATUS_ENUM.KEYS.STARTED);
    }
}



// WEBPACK FOOTER //
// ./src/app/components/modals/planning/needs/deadline/index.js